import { FC, useEffect, useState } from "react";
import { IconButton, Stack, TextField } from "@mui/material";

import { BoothClientModel } from "./UpdateBoothId";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

interface BoothComponentProps {
    booth: BoothClientModel;
    remove: (boothId: BoothClientModel) => void;
}

const BoothComponent: FC<BoothComponentProps> = ({ booth, remove }) => {
    const [name, setName] = useState<string>("");
    const [boothId, setBoothId] = useState<string>("");
    const [location, setLocation] = useState<string>("");

    useEffect(() => {
        setName(booth.name);
        setBoothId(booth.boothId);
        if (booth.location === null)
            booth.location = "";
        setLocation(booth.location);
    }, [booth])

    function SetName(event: any) {
        var value = event.target.value;
        setName(value);
        booth.name = value;
    }

    function SetBoothId(event: any) {
        var value = event.target.value;
        setBoothId(value);
        booth.boothId = value;
    }

    function SetLocation(event: any) {
        var value = event.target.value;
        setLocation(value);
        booth.location = value;
    }

    return (
        <Stack
            spacing={-1.5}
            sx={{ paddingBottom: "7px" }}>
            {/* Name */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '100px' }}>Client name: </p>
                <TextField
                    value={name}
                    onChange={SetName}
                    sx={{ width: "170px" }}
                    size="small" />
            </Stack>

            {/* BoothId */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '100px' }}>BoothId: </p>
                <TextField
                    value={boothId}
                    onChange={SetBoothId}
                    sx={{ width: "170px" }}
                    size="small" />
            </Stack>

            {/* Location */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '100px' }}>Location: </p>
                <TextField
                    value={location}
                    onChange={SetLocation}
                    sx={{ width: "170px" }}
                    size="small" />
            </Stack>

            <IconButton
                color="error"
                size="large"
                sx={{ width: "30px", height: "30px", left: "240px", top: "5px" }}
                onClick={() => { remove(booth) }}>
                <DeleteForeverIcon />
            </IconButton>
        </Stack>
    )
}

export default BoothComponent;